import {Component, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";

@Component({
  selector: 'app-insights-help-modal',
  templateUrl: './insights-help-modal.component.pug',
  styleUrls: ['./insights-help-modal.component.scss'],
  standalone: false
})
export class InsightsHelpModalComponent implements OnInit {

  constructor(public _bsModalRef: BsModalRef,) {
  }

  ngOnInit(): void {
  }

  close() {
    this._bsModalRef.hide();
  }
}
